import { useEffect, useState } from "react";
import "../MainBox.css";
import PBIReportFilter from "../../PowerBI/PBIReportFilter";
import VisualFilterPBI from "../../PowerBI/VisualFilterPBI";
import SpecFormDK from "./SpecForm-DK";
import Forecast from "./Forecast-DK";
import NotesDK from "./Notes-DK";
import OverViewDK from "./OverView-DK";
import SeriesDK from "./SeriesDK";
import PRHLoader from "../../lib/PRHLoader";

export default function accord(props) {
   // const [activeIndex, setActiveIndex] = useState([]);
    const [billingId, setBillingId] = useState(null);
    const [billingFilter, setBillingFilter] = useState(null);
    const [printInstruction, setPrintInstruction] = useState(null);
    const [printInstructionfilter, setPrintInstructionfilter] = useState(null);
    const [posId, setPosId] = useState(null);
    const [posfilter, setPosFilter] = useState(null);
    const [marketingId, setMarketingId] = useState(null);
    const [marketingFilter, setMarketingFilter] = useState(null);
    const [reportData, setReportData] = useState(null);    
    const handleAccordionClick = (index) => {
        const indexExists = props?.DKAccordSetting.includes(index);
        //const indexExists = activeIndex.includes(index);
        if (indexExists) {
            //setActiveIndex(activeIndex.filter((i) => i != index));
            props.setDKAccordSetting(props?.DKAccordSetting.filter((i) => i != index));
        } else {
            //setActiveIndex([...activeIndex, index]);
            props.setDKAccordSetting([...props?.DKAccordSetting, index]);
        }
    };


    useEffect(() => {
        if (props?.reportData && props?.reportData.length > 0) {            
            let newReportData = [];
            props?.reportData.forEach(item => {
                newReportData.push({ ...item, filters: JSON.parse(item.filters) });
            })
            setReportData(newReportData);

            setBillingId(props?.reportData.find(report => report?.reportName === "Billings"));
            setPosId(props?.reportData.find(report => report?.reportName === "POS"));
            setMarketingId(props?.reportData.find(report => report?.reportName === "Marketing"));
            setPrintInstruction(props?.reportData.find(report => report?.reportName === "Print Instructions"));
            setPrintInstructionfilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Print Instructions")?.filters ?? null));
            setMarketingFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Marketing")?.filters ?? null));
            setBillingFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Billings")?.filters ?? null));
            setPosFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "POS")?.filters ?? null));
        }
    }, [props.reportData])

    const getReportConfig = (name) => {
        if (reportData)
        return reportData.find(report => report?.reportName == name) ?? null;
    }
/*    useEffect(() => {
        //setActiveIndex(props?.DKAccordSetting);
    }, [props?.DKAccordSetting]);*/
    return (
        <div className="accordion">
            <div className={`accordion-item ${props?.DKAccordSetting.includes(0) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(0)}>
                    Notes
                </div>
                <div className="accordion-content accordian-border">
                    <NotesDK isEditable={props.isEditable} onchangeNote={props.onchangeNote} upn={props.upn} ISBNId={props.ISBNId} metaData={props.metaData} userInitials={props.userInitials} isMetaLoading={props.isMetaLoading} />
                </div>
            </div>
            <div className={`accordion-item ${props?.DKAccordSetting.includes(1) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(1)}>
                    Forecast & Reprint
                </div>
                <div className="accordion-content accordian-border">
                    <Forecast isEditable={props.isEditable} ISBNId={props.ISBNId} upn={props.upn} metaData={props.metaData} />
                </div>
            </div>
           <div className={`accordion-item ${props?.DKAccordSetting.includes(2) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(2)}>
                   Demand DK
                </div>
                <div className="accordion-content accordian-border">
                    {billingId?.reportId &&
                        <PBIReportFilter
                            BiToken={props.BiToken}
                            name='Billings'
                            //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                            reportId={billingId?.reportId}
                            filterValues={billingFilter}
                        // filterValue={props.ISBNId}
                        />}
                    <hr />
                    {posId?.reportId &&
                        <PBIReportFilter
                            BiToken={props.BiToken}
                            name='POS'
                            //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                            reportId={posId?.reportId}
                            filterValues={posfilter}
                        // filterValue={props.ISBNId}
                        />}
                </div>
            </div>
            <div className={`accordion-item ${props?.DKAccordSetting.includes(4) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(4)}>
                    Production DK
                </div>
                <div className="accordion-content accordian-border">
                    <SpecFormDK setOnChangeNote={props.setOnChangeNote} metaData={props.metaData} ISBNId={props.ISBNId} upn={props.upn} isEditable={props?.isEditable} />
                    {printInstruction?.reportId && <><div className="mb-2">
                        Print Instructions </div>
                        <PBIReportFilter
                            BiToken={props.BiToken}
                            name='Print Instructions'
                            //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                            reportId={printInstruction?.reportId}
                            filterValues={printInstructionfilter}
                            config={getReportConfig('Print Instructions')}
                        // filterValue={props.ISBNId}
                        /></>}
                </div>
            </div>
            < div className={`accordion-item ${props?.DKAccordSetting.includes(9) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(9)}>
                    Series & Author Works
                </div>
                <div className="accordion-content accordian-border">
                    <SeriesDK ISBNId={props.ISBNId} metaData={props.metaData} isbnData={props?.isbnData} setIsbnData={props?.setIsbnData} upn={props.upn} />
                </div>
            </div>
            <div className={`accordion-item ${props?.DKAccordSetting.includes(3) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(3)}>
                    Stock Overview
                </div>
                <div className="accordion-content accordian-border">
                    <br />
                    <OverViewDK ISBNId={props.ISBNId} metaData={props.metaData}></OverViewDK>
                    <div style={{ paddingBottom: "20px" }}>
                        <a target="_blank" style={{ display: "inline", marginRight: "65px", marginLeft: "20px" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?inv_drill=&isbn=${props.ISBNId}&tab=15`}>Inventory Overview</a>
                        <a target="_blank" style={{ display: "inline", marginRight: "65px" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${props.ISBNId}&tab=15&cache=false&inv_drill=GI`}>Inventory Detail</a>
                        <a target="_blank" style={{ display: "inline" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${props.ISBNId}&tab=15&cache=false&inv_drill=SO`}>Open Sales Orders</a>
                    </div>
                </div>
            </div>
         
            <div className={`accordion-item ${props?.DKAccordSetting.includes(5) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(5)}>
                    Marketing & Publicity
                </div>
                <div className="accordion-content accordian-border">
                    <div className="accordion-content accordian-border">
                        {marketingId?.reportId &&
            <PBIReportFilter
                            BiToken={props.BiToken}
                            name='Marketing'
                            reportId={marketingId?.reportId}
                            filterValues={marketingFilter}
                    />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}